<template>
  <v-container>
    <Loader v-if="isLoading" />
    <div v-else-if="!isLoading && !conversation" class="pa-4 not-found-wrapper" outlined>
      <v-row align="center" justify="center" class="text-center">
        <v-col cols="12">
          <v-icon size="48" color="grey">mdi-alert-circle-outline</v-icon>
        </v-col>
        <v-col cols="12">
          <div class="text-h6">
            {{ $vuetify.lang.t("$vuetify.gpt_history.conversation_not_found") }}
          </div>
          <!-- <div class="caption grey--text">
            {{ $vuetify.lang.t("$vuetify.gpt_history.conversation_load_error") }}
          </div> -->
        </v-col>
      </v-row>
    </div>
    <div v-else>
      <v-list>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="coversation_detail_header">
              <div class="d-flex justify-space-between align-center">
                <div>
                  <strong>
                    {{
                      this.$vuetify.lang.t(
                        "$vuetify.gpt_history.gpt_history_conversation_id"
                      )
                    }}:
                  </strong>
                  <span class="response-details-text">
                    {{ conversation.conversationId }}
                  </span>
                  <v-btn
                    icon
                    small
                    @click="
                      copyToClipboard(
                        conversation.conversationId,
                        'Conversation ID copied to clipboard'
                      )
                    "
                  >
                    <v-icon>mdi-content-copy</v-icon>
                  </v-btn>
                </div>
                <div>
                  <v-btn
                    class="green darken-1 white--text capitalize"
                    @click="sharePublicUri"
                  >
                    <v-icon left>mdi-share-variant</v-icon>
                    {{ this.$vuetify.lang.t("$vuetify.common.share_btn_txt") }}
                  </v-btn>
                  <div
                    v-if="credentialModal"
                    style="
                      position: absolute;
                      top: 0;
                      right: 0;
                      z-index: 1;
                      width: 20%;
                    "
                  >
                    <v-card>
                      <v-card-title class="text-h5">
                        {{
                          this.$vuetify.lang.t(
                            "$vuetify.gpt_history_details.share_credentials_header"
                          )
                        }}
                      </v-card-title>
                      <v-card-subtitle class="text-subtitle-2">
                        <v-icon
                          class="mr-1"
                          color="blue darken-1
                        "
                          >mdi-information</v-icon
                        >
                        {{
                          this.$vuetify.lang.t(
                            "$vuetify.gpt_history_details.share_credentials_info"
                          )
                        }}
                      </v-card-subtitle>

                      <v-card-text>
                        <v-form ref="credentialForm">
                          <v-text-field
                            v-model="project_key"
                            :label="
                              this.$vuetify.lang.t(
                                '$vuetify.project_credentials.project_key_label_txt'
                              )
                            "
                            outlined
                            :rules="[
                              v =>
                                !client_key && api_key
                                  ? !!v ||
                                    this.$vuetify.lang.t(
                                      '$vuetify.gpt_history_details.credential_form.project_key_required_txt'
                                    )
                                  : true,
                            ]"
                          ></v-text-field>
                          <v-text-field
                            v-model="api_key"
                            :label="
                              this.$vuetify.lang.t(
                                '$vuetify.project_credentials.api_key_label_txt'
                              )
                            "
                            outlined
                            :rules="[
                              v =>
                                !client_key && project_key
                                  ? !!v ||
                                    this.$vuetify.lang.t(
                                      '$vuetify.gpt_history_details.credential_form.api_key_required_txt'
                                    )
                                  : true,
                            ]"
                          ></v-text-field>
                          <v-container
                            class="d-flex align-center justify-center mb-2"
                          >
                            <v-divider class="flex-grow-1 mx-2"></v-divider>
                            <span class="mx-2">OR</span>
                            <v-divider class="flex-grow-1 mx-2"></v-divider>
                          </v-container>
                          <v-text-field
                            v-model="client_key"
                            :label="
                              this.$vuetify.lang.t(
                                '$vuetify.project_credentials.client_key_label_txt'
                              )
                            "
                            outlined
                            :rules="[
                              v =>
                                !project_key && !api_key
                                  ? !!v ||
                                    this.$vuetify.lang.t(
                                      '$vuetify.gpt_history_details.credential_form.client_key_required_txt'
                                    )
                                  : true,
                            ]"
                          ></v-text-field>
                        </v-form>
                      </v-card-text>

                      <v-card-actions>
                        <v-spacer></v-spacer>

                        <v-btn
                          color="red darken-1"
                          text
                          @click="credentialModal = false"
                        >
                          {{
                            this.$vuetify.lang.t("$vuetify.common.close_btn")
                          }}
                        </v-btn>

                        <v-btn
                          color="green darken-1"
                          text
                          @click="manualLinkShare"
                        >
                          {{
                            this.$vuetify.lang.t(
                              "$vuetify.common.share_btn_txt"
                            )
                          }}
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </div>
                </div>
              </div>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              <strong>{{ $vuetify.lang.t("$vuetify.gpt_history.status") }}:</strong>
              <v-chip
                class="ml-2"
                small
                dark
                :color="conversation.messageSeen === false ? 'grey' : 'primary'"
              >
                {{ conversation.messageSeen === false ? "Unseen" : "Seen" }}
              </v-chip>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              <strong>
                {{
                  this.$vuetify.lang.t(
                    "$vuetify.gpt_history.gpt_history_user_id"
                  )
                }}:
              </strong>
              <span class="response-details-text">
                {{ conversation.requestBody?.userId }}
              </span>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              <strong>
                {{
                  this.$vuetify.lang.t(
                    "$vuetify.gpt_history.gpt_history_user_name"
                  )
                }}:
              </strong>
              <span class="response-details-text">
                {{ conversation.requestBody?.userName }}
              </span>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              <strong>
                {{
                  this.$vuetify.lang.t(
                    "$vuetify.gpt_history.gpt_history_member_id"
                  )
                }}:
              </strong>
              <span class="response-details-text">
                {{ conversation.requestBody?.memberId }}
              </span>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title class="">
              <strong>
                {{
                  this.$vuetify.lang.t(
                    "$vuetify.gpt_history.gpt_history_query"
                  )
                }}:
              </strong>
              <span class="response-message">
                {{ conversation.requestBody?.query }}
              </span>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              <strong>
                {{
                  this.$vuetify.lang.t(
                    "$vuetify.gpt_history.gpt_history_response"
                  )
                }}:
              </strong>
              <v-card flat class="mt-1">
                <v-card-text
                  class="pa-1 reference-content"
                  @click="handleResponseClick"
                >
                  <div v-html="formatMarkdown(normalizeTextContent(conversation.response))"></div>
                </v-card-text>
              </v-card>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <template v-if="conversation.evaluation">
          <v-card flat>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title>
                  <strong>
                    {{
                      this.$vuetify.lang.t(
                        "$vuetify.gpt_history.gpt_history_is_evaluation"
                      )
                    }}:
                  </strong>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-card-subtitle>
              <v-chip color="primary" label small>
                <v-icon left small>mdi-star</v-icon>
                {{
                  this.$vuetify.lang.t(
                    "$vuetify.gpt_history.gpt_history_score"
                  )
                }}:
                {{ conversation.evaluation.response_score || 0 }}
              </v-chip>
            </v-card-subtitle>
          </v-card>
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>
                <strong>
                  {{
                    this.$vuetify.lang.t(
                      "$vuetify.gpt_history.gpt_top_references"
                    )
                  }}:
                </strong>
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-data-table
            v-if="
              conversation.evaluation.top_references &&
              conversation.evaluation.top_references.length
            "
            :headers="evaluationHeaders"
            :items="conversation.evaluation.top_references"
            :items-per-page="5"
            :mobile-breakpoint="0"
            show-expand
            item-key="score"
          >
            <template v-slot:item.score="{ item }">
              <v-chip :color="getScoreColor(item.score)" dark small>
                <span class="subtitle-2">{{ item.score }}</span>
              </v-chip>
            </template>
            <template v-slot:item.index="{ item }">
              <span>{{ formatIndexValues(item) }}</span>
            </template>
            <template v-slot:item.dataset_id="{ item }">
              <span>{{ item.dataset_id || "N/A" }}</span>
            </template>
            <template v-slot:item.source="{ item }">
              <span>{{ item.source || "N/A" }}</span>
            </template>
            <template v-slot:expanded-item="{ headers, item }">
              <td :colspan="headers.length">
                <template v-if="item.source === 'conversation_context'">
                  <v-sheet
                    v-if="
                      conversation.conversationContext &&
                      conversation.conversationContext.length
                    "
                    max-height="300px"
                    class="overflow-y-auto"
                  >
                    <v-list dense class="py-0">
                      <v-list-item
                        v-for="(
                          context, index
                        ) in conversation.conversationContext"
                        :key="index"
                      >
                        <v-list-item-content>
                          <v-list-item-subtitle
                            class="text--primary text-caption text-sm-body-2"
                          >
                            <strong>User:</strong>
                            {{ context.user }}
                          </v-list-item-subtitle>
                          <v-list-item-subtitle
                            class="text-wrap text-caption text-sm-body-2"
                          >
                            <strong>Assistant:</strong>
                            {{ context.assistant }}
                          </v-list-item-subtitle>
                          <v-list-item-subtitle class="text-caption">
                            <strong>Timestamp:</strong>
                            {{ formatDateTime(context.timestamp) }}
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-sheet>
                </template>
                <template v-else-if="item.source === 'dataset'">
                  <VueMarkdown>
                    {{
                      getUniqueReferences(conversation.references)
                        ?.find(
                          ref =>
                            ref?.section_id ===
                            formatIndexValues(item).split(": ")[1]
                        )
                        ?.content.replace(
                          /(^|\s)(\b(?!http|https)\w+):/g,
                          "$1**$2**:"
                        ) || "N/A"
                    }}
                  </VueMarkdown>
                </template>
              </td>
            </template>
          </v-data-table>
        </template>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              <strong>
                {{
                  this.$vuetify.lang.t("$vuetify.gpt_history.gpt_history_date")
                }}:
              </strong>
              <span class="response-details-text">
                {{ formatDateTime(conversation.createdAt) }}
              </span>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              <strong>
                {{
                  this.$vuetify.lang.t(
                    "$vuetify.gpt_history.gpt_history_processing_time"
                  )
                }}:
              </strong>
              <span class="response-details-text">
                {{ conversation.processTime }}
              </span>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              <strong>
                {{
                  this.$vuetify.lang.t(
                    "$vuetify.gpt_history.gpt_history_model"
                  )
                }}:
              </strong>
              <span class="response-details-text">
                {{ conversation.requestBody.model }}
              </span>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              <strong>
                {{
                  this.$vuetify.lang.t(
                    "$vuetify.gpt_history.gpt_history_chat_history_length"
                  )
                }}:
              </strong>
              <span class="response-details-text">
                {{ conversation.requestBody.chatHistoryLength }}
              </span>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              <strong>
                {{
                  this.$vuetify.lang.t(
                    "$vuetify.gpt_history.gpt_history_temperature"
                  )
                }}:
              </strong>
              <span class="response-details-text">
                {{ conversation.requestBody.temperature }}
              </span>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              <strong>Top P:</strong>
              <span class="response-details-text">
                {{ conversation.requestBody.topP }}
              </span>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              <strong>Top K:</strong>
              <span class="response-details-text">
                {{ conversation.requestBody.topK }}
              </span>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              <strong>
                {{
                  this.$vuetify.lang.t(
                    "$vuetify.gpt_history.gpt_history_search_max_token"
                  )
                }}:
              </strong>
              <span class="response-details-text">
                {{ conversation.requestBody.searchMaxToken }}
              </span>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              <strong>
                {{
                  this.$vuetify.lang.t(
                    "$vuetify.gpt_history.gpt_history_frequency_penalty"
                  )
                }}:
              </strong>
              <span class="response-details-text">
                {{ conversation.requestBody.frequencyPenalty }}
              </span>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              <strong>
                {{
                  this.$vuetify.lang.t(
                    "$vuetify.gpt_history.gpt_history_presence_penalty"
                  )
                }}:
              </strong>
              <span class="response-details-text">
                {{ conversation.requestBody.presencePenalty }}
              </span>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              <strong>Stop:</strong>
              <span class="response-details-text">
                {{
                  conversation.requestBody.stop &&
                  conversation.requestBody.stop.join(", ")
                }}
              </span>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              <strong>
                {{
                  this.$vuetify.lang.t(
                    "$vuetify.gpt_history.gpt_history_result_includes"
                  )
                }}:
              </strong>
              <span class="response-details-text">
                {{
                  conversation.requestBody.resultIncludes &&
                  conversation.requestBody.resultIncludes.join(", ")
                }}
              </span>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              <strong>Session ID:</strong>
              <span class="response-details-text">
                {{ conversation.requestBody.sessionId }}
              </span>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              <strong>GPT Profile Id:</strong>
              <span class="response-details-text">
                {{ conversation.gptProfileId }}
              </span>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              <strong>
                {{
                  this.$vuetify.lang.t(
                    "$vuetify.gpt_history.gpt_history_profile_name"
                  )
                }}:
              </strong>
              <span class="response-details-text">
                {{ conversation.requestBody.name }}
              </span>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              <strong>Intro:</strong>
              <span class="response-details-text">
                {{ conversation.requestBody.intro }}
              </span>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              <strong>
                {{
                  this.$vuetify.lang.t(
                    "$vuetify.gpt_history.gpt_history_system"
                  )
                }}:
              </strong>
              <span class="response-details-text">
                {{ conversation.requestBody.system }}
              </span>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              <strong>
                {{
                  this.$vuetify.lang.t(
                    "$vuetify.gpt_history.gpt_history_conversation_type"
                  )
                }}:
              </strong>
              <span class="response-details-text">
                {{ conversation.requestBody.conversationType }}
              </span>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              <v-row class="mt-0">
                <v-col class="py-0 pr-0" cols="12" md="auto">
                  <div class="font-weight-bold pt-2">
                    {{
                      this.$vuetify.lang.t(
                        "$vuetify.gpt_history.gpt_history_feedback_message"
                      )
                    }}:
                  </div>
                </v-col>
                <template v-if="!isEditing">
                  <v-col class="py-0 w-100">
                    <div
                      :class="[
                        'response-details-text pt-2',
                        isPrivate ? 'd-inline' : '',
                      ]"
                    >
                      {{
                        conversation.feedback &&
                        conversation.feedback.message !== undefined &&
                        conversation.feedback.message !== null &&
                        conversation.feedback.message !== ""
                          ? conversation.feedback.message
                          : updatedData.message !== undefined &&
                              updatedData.message !== null &&
                              updatedData.message !== ""
                            ? updatedData.message
                            : "N/A"
                      }}
                    </div>
                    <v-btn v-if="isPrivate" @click="toggleEditing" icon 
                    :disabled="!$hasProjectAccessFor([$pRole.ADMIN])"
                    >
                      <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                  </v-col>
                </template>
                <template v-else>
                  <v-col class="py-2 w-100">
                    <v-textarea
                      v-if="isEditing"
                      v-model="editedFeedback"
                      label=""
                      placeholder="Write your feedback here..."
                      auto-grow
                      :rows="dynamicRowCount"
                      max-rows="8"
                      outlined
                      dense
                    ></v-textarea>
                    <v-form ref="feedbackTextarea">
                      <div
                        class="d-flex flex-column flex-sm-row justify-space-between align-center"
                      >
                        <div>
                          <v-radio-group
                            v-if="isEditing"
                            v-model="editedFeedbackType"
                            row
                            class="response-details-text mt-0 flex-column flex-sm-row"
                            :rules="[
                              v =>
                                !!v ||
                                this.$vuetify.lang.t(
                                  '$vuetify.insights.feedback_type_required'
                                ),
                            ]"
                          >
                            <v-radio
                              :label="
                                this.$vuetify.lang.t(
                                  '$vuetify.insights.positive'
                                )
                              "
                              value="positive"
                            ></v-radio>
                            <v-radio
                              :label="
                                this.$vuetify.lang.t(
                                  '$vuetify.insights.negative'
                                )
                              "
                              value="negative"
                            ></v-radio>
                          </v-radio-group>
                        </div>
                        <div>
                          <v-row align="center" v-if="isEditing">
                            <v-col>
                              <v-btn
                                outlined
                                @click="cancelEditing"
                                class="mr-2"
                                color="red"
                              >
                                {{
                                  this.$vuetify.lang.t("$vuetify.common.cancel")
                                }}
                              </v-btn>
                              <v-btn
                                @click.prevent="saveEditedFeedback"
                                color="primary"
                                outlined
                              >
                                {{
                                  this.$vuetify.lang.t("$vuetify.common.save")
                                }}
                              </v-btn>
                            </v-col>
                          </v-row>
                        </div>
                      </div>
                    </v-form>
                  </v-col>
                </template>
              </v-row>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              <strong>Sections:</strong>
              <span class="response-details-text">
                {{ conversation.sections && conversation.sections.join(", ") }}
              </span>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              <strong>
                {{
                  this.$vuetify.lang.t(
                    "$vuetify.gpt_history.gpt_history_context_preference"
                  )
                }}:
              </strong>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              <p style="margin-left: 20px; font-weight: 500">Preferred:</p>
              <!-- <span style="margin-left: 40px">Dataset ID:</span>
              <span class="response-details-text">
                {{
                  conversation.requestBody.contextPreference &&
                  conversation.requestBody.contextPreference.preferred &&
                  conversation.requestBody.contextPreference.preferred.datasetId
                }}
              </span> -->
              <!-- <p></p> -->
              <!-- <span style="margin-left: 40px">Project ID:</span> -->
              <!-- <span class="response-details-text">
                {{
                  conversation.requestBody.contextPreference &&
                  conversation.requestBody.contextPreference.preferred &&
                  conversation.requestBody.contextPreference.preferred.projectId
                }}
              </span> -->
              <span class="response-details-text">
                <template
                  v-if="conversation.requestBody.contextPreference?.preferred"
                >
                  <div
                    class="pa-1"
                    v-for="(value, key) in conversation.requestBody
                      .contextPreference.preferred"
                    :key="key"
                  >
                    <span class="ml-5 font-weight-bold pe-2">{{ key }}</span
                    >: {{ value }}
                  </div>
                </template>
              </span>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              <p style="margin-left: 20px; font-weight: 500">Excludes:</p>
              <span class="response-details-text">
                <template
                  v-if="conversation.requestBody.contextPreference?.excludes"
                >
                  <div
                    class="pa-1"
                    v-for="(value, key) in conversation.requestBody
                      .contextPreference.excludes"
                    :key="key"
                  >
                    <span class="ml-5 font-weight-bold pe-2">{{ key }}</span
                    >: {{ value }}
                  </div>
                </template>
              </span>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              <strong>
                {{
                  this.$vuetify.lang.t(
                    "$vuetify.gpt_history.gpt_history_conversation_metadata"
                  )
                }}:
              </strong>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          v-if="
            conversation.requestBody.conversationMetadata &&
            Object.keys(conversation.requestBody.conversationMetadata).length >
              0
          "
        >
          <v-list-item-content>
            <span class="response-details-text">
              <template>
                <div
                  class="pa-1"
                  v-for="(value, key) in conversation.requestBody
                    .conversationMetadata"
                  :key="key"
                >
                  <span class="ml-5 font-weight-bold pe-2">{{ key }}</span
                  >: {{ value }}
                </div>
              </template>
            </span>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              <strong>Usage:</strong>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              <span style="margin-left: 20px; font-weight: 500">
                {{
                  this.$vuetify.lang.t(
                    "$vuetify.gpt_history.gpt_history_completion_tokens"
                  )
                }}:
              </span>
              <span>
                {{ conversation.usage && conversation.usage.completionTokens }}
              </span>
              <p></p>
              <span style="margin-left: 20px; font-weight: 500">
                {{
                  this.$vuetify.lang.t(
                    "$vuetify.gpt_history.gpt_history_prompt_tokens"
                  )
                }}:
              </span>
              <span>
                {{ conversation.usage && conversation.usage.promptTokens }}
              </span>
              <p></p>
              <span style="margin-left: 20px; font-weight: 500">
                {{
                  this.$vuetify.lang.t(
                    "$vuetify.gpt_history.gpt_history_query_tokens"
                  )
                }}:
              </span>
              <span>
                {{ conversation.usage && conversation.usage.queryTokens }}
              </span>
              <p></p>
              <span style="margin-left: 20px; font-weight: 500">
                {{
                  this.$vuetify.lang.t(
                    "$vuetify.gpt_history.gpt_history_total_tokens"
                  )
                }}:
              </span>
              <span>
                {{ conversation.usage && conversation.usage.totalTokens }}
              </span>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              <strong>
                {{
                  this.$vuetify.lang.t(
                    "$vuetify.gpt_history.gpt_history_vision_settings"
                  )
                }}:
              </strong>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              <span style="margin-left: 20px; font-weight: 500">
                {{
                  this.$vuetify.lang.t(
                    "$vuetify.gpt_history.gpt_history_image_context_enabled"
                  )
                }}:
              </span>
              <span>
                {{
                  conversation.requestBody.visionSettings &&
                  conversation.requestBody.visionSettings
                    .is_image_context_enabled
                }}
              </span>
              <p></p>
              <span style="margin-left: 20px; font-weight: 500">
                {{
                  this.$vuetify.lang.t(
                    "$vuetify.gpt_history.gpt_history_is_conversation_learning"
                  )
                }}:
              </span>
              <span>
                {{
                  conversation.requestBody.visionSettings &&
                  conversation.requestBody.visionSettings
                    .is_conversation_learning
                }}
              </span>
              <p></p>
              <span style="margin-left: 20px; font-weight: 500">
                {{
                  this.$vuetify.lang.t(
                    "$vuetify.gpt_history.gpt_history_resolution"
                  )
                }}:
              </span>
              <span>
                {{
                  conversation.requestBody.visionSettings &&
                  conversation.requestBody.visionSettings.resolution
                }}
              </span>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              <strong>
                {{
                  this.$vuetify.lang.t(
                    "$vuetify.gpt_history.gpt_history_references"
                  )
                }}:
              </strong>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <template v-if="conversation.references">
          <v-data-table
            :headers="gptReferenceHeaders"
            :items="getUniqueReferences(conversation.references)"
            :items-per-page="5"
            show-expand
            item-key="section_id"
          >
            <template v-slot:[`item.content`]="{ item }">
              <span>
                {{ item.content && item.content.substring(0, 60) }}
                ...
              </span>
            </template>
            <template v-slot:expanded-item="{ headers, item }">
              <td class="word-break" :colspan="headers.length">
                <VueMarkdown>
                  {{
                    item?.content.replace(
                      /(^|\s)(\b(?!http|https)\w+):/g,
                      "$1**$2**:"
                    )
                  }}
                </VueMarkdown>
              </td>
            </template>
            <template v-slot:[`item.action`]="{ item }">
              <v-icon
                v-if="isPrivate"
                small
                @click="redirectDocumentPage(item)"
                :disabled="!$hasProjectAccessFor([$pRole.ADMIN])"
              >
                mdi-pencil
              </v-icon>
            </template>
          </v-data-table>
        </template>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              <strong>
                {{
                  this.$vuetify.lang.t(
                    "$vuetify.gpt_history.gpt_conversation_context"
                  )
                }}:
              </strong>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-card
              flat
              class="ml-4"
              style="max-height: 400px; overflow-y: auto"
            >
              <v-expansion-panels flat>
                <v-expansion-panel
                  v-for="(context, index) in sortConverstionContext(conversation.conversationContext)" 
                  :key="index"
                >
                  <v-expansion-panel-header>
                    <v-container fluid class="pa-0">
                      <v-row no-gutters align="center">
                        <v-col
                          cols="12"
                          sm="4"
                          md="2"
                          class="d-flex align-center mb-1 mb-sm-0"
                        >
                          <span class="text-subtitle-2 font-weight-medium">
                            Conversation-{{ index + 1 }}
                          </span>
                        </v-col>
                        <v-col
                          cols="12"
                          sm="8"
                          md="10"
                          class="d-flex flex-wrap align-center"
                        >
                          <v-chip x-small label outlined class="mr-2 mb-1">
                            <span class="text-subtitle-2">{{
                              context.user
                            }}</span>
                          </v-chip>
                          <span class="text-caption grey--text">
                            {{ formatDateTime(context.timestamp) }}
                          </span>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-card-text>
                      <strong class="primary--text">Assistant:</strong>
                      <VueMarkdown>
                        {{ normalizeTextContent(context.assistant) }}
                      </VueMarkdown>
                    </v-card-text>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-card>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </div>
    <!-- Preview Modal -->
    <PreviewModal
      v-model="previewModal.show"
      :title="previewModal.title"
      :referenceData="previewModal.referenceData"
      :contentType="previewModal.contentType"
    />
  </v-container>
</template>

<script>
import { mapActions } from "vuex";
import VueMarkdown from "vue-markdown";

import Loader from "@/components/common/loader/Loader";
import {
  ADD_ALERT,
  RECOMMENDER_UPDATE_FEEDBACK,
  RETRIEVE_GPT_CONVERSATION_DETAIL,
  LOAD_PROJECT_BY_ID
} from "@/store/_actiontypes";
import {
  decryptData,
  encryptData,
  getUniqueArrayOfObjects,
} from "@/helpers/helper";
import PreviewModal from "@/components/common/PreviewModal";
import { CONTENT_TYPES } from "@/global/_constants";

const escapeHtml = (str) =>
  str
    .replace(/&/g, "&amp;")
    .replace(/"/g, "&quot;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");

const CLOSING_BRACKETS = { ")": "(", "]": "[", "}": "{" };

const readSafeAttribute = (rawAnchor, attrName) => {
  const match = new RegExp(`${attrName}\\s*=\\s*(?:"([^"]*)"|'([^']*)')`, 'i').exec(rawAnchor);
  return match ? (match[1] ?? match[2] ?? '') : '';
};

/**
 * Rebuilds a raw <a>...</a> tag pulled verbatim from the LLM response into a safe, fixed-shape anchor - discarding every original attribute (event handlers like onclick/onerror, javascript: hrefs, style, etc.) and keeping only a validated http(s) href, the citation attributes (data-section-id/data-dataset-id) the backend uses for CSV/JSON references, plus escaped, tag-stripped link text.
 * This output is fed into v-html with no further sanitization, so nothing from the original tag may survive except through this allowlist. `data-plain-link` is deliberately never set here - these anchors come from the LLM's citation markup (see gpt_flow.py's citation prompt), so clicks must keep going through handleResponseClick()'s reference lookup rather than navigating away; that marker is reserved for the Markdown-link/bare-URL anchors built elsewhere. Anchors with neither a safe href nor citation attributes degrade to plain text instead of staying a dead or unsafe link.
 */
const sanitizeRawAnchorTag = (rawAnchor) => {
  const hrefMatch = /href\s*=\s*(?:"([^"]*)"|'([^']*)'|([^\s>]+))/i.exec(rawAnchor);
  const href = hrefMatch ? (hrefMatch[1] ?? hrefMatch[2] ?? hrefMatch[3] ?? '') : '';
  const sectionId = readSafeAttribute(rawAnchor, 'data-section-id');
  const datasetId = readSafeAttribute(rawAnchor, 'data-dataset-id');
  const innerMatch = /<a[^>]*>([\s\S]*?)<\/a>/i.exec(rawAnchor);
  const innerText = (innerMatch ? innerMatch[1] : '').replace(/<[^>]*>/g, '').trim();
  const safeLabel = escapeHtml(innerText || href || 'link');

  const isSafeHref = /^https?:\/\//i.test(href);
  const citationAttrs = [
    sectionId && `data-section-id="${escapeHtml(sectionId)}"`,
    datasetId && `data-dataset-id="${escapeHtml(datasetId)}"`,
  ].filter(Boolean).join(' ');

  if (!isSafeHref && !citationAttrs) {
    return safeLabel;
  }

  const hrefAttr = isSafeHref ? `href="${escapeHtml(href)}" target="_blank" rel="noopener noreferrer" ` : '';
  return `<a ${hrefAttr}${citationAttrs} data-citation-link="true">${safeLabel}</a>`;
};

// Our own generated-asset bucket only (AWS_S3_BUCKET_NAME_TS in maira-api), matching isMairaGenAiBucketUrl in maira-app;
// the optional suffix covers the per-environment names (maira-genai-assets, maira-genai-assets-stg).
const MAIRA_GEN_AI_BUCKET_HOSTNAME_RE = /^maira-genai-assets(-[a-z0-9]+)?\.s3([.-][a-z0-9-]+)?\.amazonaws\.com$/i;

/** True when a URL points specifically at our own generated-asset S3 bucket. */
const isMairaGenAiBucketUrl = (url) => {
  try {
    return MAIRA_GEN_AI_BUCKET_HOSTNAME_RE.test(new URL(url).hostname);
  } catch (e) {
    return false;
  }
};

/**
 * Fixed-shape rebuild of an untrusted raw <img>: every attribute dropped, only a bucket-checked src + escaped alt kept, else the "blocked" placeholder.
 * Needed because the backend emits time-series plots as raw <img>, not markdown ![]() (time_series.py's image_html).
 */
const sanitizeRawImgTag = (rawImg) => {
  const src = readSafeAttribute(rawImg, 'src').trim();
  const alt = readSafeAttribute(rawImg, 'alt');
  const isSafeUrl = /^https:\/\//i.test(src) && isMairaGenAiBucketUrl(src);
  if (!isSafeUrl) {
    return `<span title="Blocked unsafe image URL"></span>`;
  }
  return `<img src="${escapeHtml(src)}" alt="${escapeHtml(alt)}" style="max-width: 100%; height: auto;">`;
};

/**
 * Scans forward from just after "](" to find the ")" that actually closes the markdown link, correctly balancing any parentheses that are part of the URL itself.
 * Returns -1 if the link is unterminated or the URL contains whitespace, mirroring the old [^\s)]+ rule.
 */
const findMarkdownLinkUrlEnd = (content, start) => {
  let depth = 1;
  for (let i = start; i < content.length; i++) {
    const char = content[i];
    if (char === "(") {
      depth++;
    } else if (char === ")") {
      depth--;
      if (depth === 0) return i;
    } else if (/\s/.test(char)) {
      return -1;
    }
  }
  return -1;
};

/**
 * Strips trailing sentence punctuation (periods, commas, etc.) and any unbalanced closing bracket/paren from an auto-detected bare URL,
 * so text like "see https://example.com." or "(https://example.com/a_(b))." doesn't pull that punctuation into the generated link.
 */
const trimTrailingUrlPunctuation = (url) => {
  // Bracket counts for the whole string, decremented as characters leave the [0, end) window below -
  // avoids re-scanning the remaining string with .split() on every character removed, which is O(n^2) on a long run of trailing closing brackets (e.g. a URL followed by ")))))...)").
  const counts = {};
  for (const ch of url) {
    if (ch in CLOSING_BRACKETS || Object.values(CLOSING_BRACKETS).includes(ch)) {
      counts[ch] = (counts[ch] || 0) + 1;
    }
  }

  let end = url.length;
  let changed = true;
  while (changed && end > 0) {
    changed = false;

    let punctuationStart = end;
    while (punctuationStart > 0 && /[.,;:!?'"]/.test(url[punctuationStart - 1])) {
      punctuationStart--;
    }
    if (punctuationStart < end) {
      end = punctuationStart;
      changed = true;
      continue;
    }

    const lastChar = url[end - 1];
    const opener = CLOSING_BRACKETS[lastChar];
    if (opener && (counts[lastChar] || 0) > (counts[opener] || 0)) {
      counts[lastChar]--;
      end--;
      changed = true;
    }
  }
  return url.slice(0, end);
};

export default {
  components: {
    Loader,
    VueMarkdown,
    PreviewModal,
  },
  watch: {
    isPrivate(newValue) {
      if (!newValue) {
        this.gptReferenceHeaders = this.gptReferenceHeaders.filter(
          header => header.value !== "action"
        );
      } else {
        this.gptReferenceHeaders.push({
          text: "Action",
          value: "action",
        });
      }
    },
    project_key(newValue) {
      if (newValue) {
        this.client_key = "";
      }
      this.$refs.credentialForm?.validate();
    },
    api_key(newValue) {
      if (newValue) {
        this.client_key = "";
      }
      this.$refs.credentialForm?.validate();
    },
    client_key(newValue) {
      if (newValue) {
        this.project_key = "";
        this.api_key = "";
      }
      this.$refs.credentialForm?.validate();
    },
  },
  mounted() {
    this.getDataFromToken();
    this.getProject();
  },
  data() {
    return {
      credentialModal: false,
      project_key: "",
      api_key: "",
      project_id: null,
      project_role: null,
      client_key: "",
      decryptedData: null,
      isPrivate: false,
      editedFeedback: "",
      editedFeedbackType: "",
      isEditing: false,
      isLoading: true,
      dynamicRowCount: 1,
      conversation: null,
      updatedData: {
        conversation_id: null,
        message: null,
        type: null,
      },
      gptReferenceHeaders: [
        {
          text: "Content",
          align: "start",
          value: "content",
        },
        {
          text: this.$vuetify.lang.t("$vuetify.insights.dataset_id"),
          align: "start",
          value: "dataset_id",
        },
        {
          text: this.$vuetify.lang.t("$vuetify.insights.index"),
          align: "start",
          value: "index",
        },
        {
          text: "Similarity Score",
          align: "start",
          value: "similarity_score",
        },
        {
          text: "Section ID",
          align: "start",
          value: "section_id",
        },
      ],
      evaluationHeaders: [
        {
          text: this.$vuetify.lang.t("$vuetify.insights.source"),
          value: "source",
        },
        {
          text: this.$vuetify.lang.t("$vuetify.insights.score"),
          value: "score",
        },
        {
          text: this.$vuetify.lang.t("$vuetify.insights.dataset_id"),
          value: "dataset_id",
        },
        {
          text: this.$vuetify.lang.t("$vuetify.insights.index"),
          value: "index",
        },
      ],
      previewModal: {
        show: false,
        title: '',
        referenceData: {
          section_id: '',
          dataset_id: '',
          reference_url: '',
          content: '',
          original_file_name: ''
        },
        contentType: CONTENT_TYPES.TEXT,
      },
    };
  },
  methods: {
    ...mapActions("gpt", [RETRIEVE_GPT_CONVERSATION_DETAIL]),
    ...mapActions("insight", [RECOMMENDER_UPDATE_FEEDBACK]),
     ...mapActions("project", [LOAD_PROJECT_BY_ID]),
    getDataFromToken() {
      const token = this.$route.query.token;
      const conversation_id = this.$route.params.conversation_id;

      if (!conversation_id) {
        this.conversation = null;
        this.isPrivate = false;
        this.project_id = null;
        this.isLoading = false;
        return;
      }

      const parts = conversation_id.split("-");
      const secretKey = `${parts[0]}#${parts[parts.length - 1]}`;
      let decrypted = null;
      try {
        decrypted = decryptData(token, secretKey);
      } catch {
        this.conversation = null;
        this.isPrivate = false;
        this.project_id = null;
        this.isLoading = false;
        return;
      }
      this.decryptedData = decrypted;
      this.isPrivate = this.decryptedData?.project_id ? true : false;
      this.project_id = this.decryptedData?.project_id || null;
      this.getConversationDetails();      
    },
    async getProject(){
      if (!this.project_id) {
        this.project_role = null;
        return;
      }
      const project = await this.LOAD_PROJECT_BY_ID({
        project_id: this.project_id,
      });
      this.project_role = project?.data?.project_role;
    },
    async getConversationDetails() {
      this.isLoading = true;
      this.decryptedData.conversation_id = this.$route.params.conversation_id;
      if (!this.decryptedData.conversation_id) {
        this.conversation = null;
        this.isLoading = false;
        return;
      }
      try {
        let res = await this.RETRIEVE_GPT_CONVERSATION_DETAIL(
          this.decryptedData
        );
        if (!res || res.error) {
          this.conversation = null;
        } else {
          this.conversation = res;
        }
      } catch (_error) {
        this.conversation = null;
      } finally {
        this.isLoading = false;
      }
    },
    // Normalizes response text content, extracting and formatting JSON if present.
    normalizeTextContent(response) {
      if (!this.isValidString(response)) {
        console.warn("Invalid response: expected a non-empty string");
        return "";
      }

      if (this.isJsonString(response)) {
        const jsonContent = this.extractJsonBlock(response);
        if (!jsonContent) {
          console.warn("No valid JSON block found in response");
          return this.normalizeBasicText(response); // Fallback
        }

        try {
          const parsed = JSON.parse(jsonContent);
          return this.formatJsonAsPlainText(parsed);
        } catch (e) {
          console.error("JSON parsing failed:", e);
        }
      }

      return this.normalizeBasicText(response);
    },
    // Normalize text formatting - handle newlines and whitespace
    normalizeBasicText(text) {
      return text
        .replace(/\\n/g, "\n")
        .replace(/\r?\n/g, "\n")
        .trim();
    },
    // Checks if a string contains a valid JSON object wrapped in Markdown code blocks.
    isJsonString(str) {
      if (!this.isValidString(str)) return false;

      const jsonContent = this.extractJsonBlock(str);
      if (!jsonContent) return false;

      try {
        JSON.parse(jsonContent);
        return true;
      } catch {
        return false;
      }
    },
    //Formats a JSON object into a human-readable string with indentation and formatting.
    formatJsonAsPlainText(obj, level = 0) {
      const indent = "  ".repeat(level);
      return (
        Object.entries(obj)
          .map(([key, value]) => {
            const formattedKey = key.replace(/_/g, " ");
            if (Array.isArray(value)) {
              const items = value
                .map((item, index) =>
                  typeof item === "object" && item !== null
                    ? `${indent}**Product ${index + 1}:**\n${this.formatJsonAsPlainText(item, level + 1)}`
                    : `${indent}• ${item}`
                )
                .join("\n");
              return `${indent}**${formattedKey}:**\n${items}`;
            } else if (typeof value === "object" && value !== null) {
              return `${indent}**${formattedKey}:**\n${this.formatJsonAsPlainText(value, level + 1)}`;
            } else {
              return `${indent}**${formattedKey}:** ${value}`;
            }
          })
          .join("\n") + "\n"
      );
    },
    isValidString(value) {
      return value && typeof value === "string" && value.trim().length > 0;
    },
    extractJsonBlock(str) {
      const jsonStart = str.indexOf("```json");
      if (jsonStart === -1) return null;

      return this.cleanMarkdown(str.substring(jsonStart));
    },
    cleanMarkdown(content) {
      return content
        .replace(/```json\n?/, "")
        .replace(/```$/, "")
        .trim();
    },
    formatDateTime(dateTimeString) {
      // new Date(null) is the epoch, not an invalid date, so a missing time would show as 1970-01-01.
      if (!dateTimeString) return "";
      const date = new Date(dateTimeString);

      if (isNaN(date.getTime())) {
        console.warn("Invalid date time string:", dateTimeString);
        return "";
      }

      const yyyy = date.getFullYear();
      const mm = String(date.getMonth() + 1).padStart(2, "0");

      const dd = String(date.getDate()).padStart(2, "0");
      const hh = String(date.getHours()).padStart(2, "0");
      const min = String(date.getMinutes()).padStart(2, "0");
      const ss = String(date.getSeconds()).padStart(2, "0");
      return `${yyyy}-${mm}-${dd} ${hh}:${min}:${ss}`;
    },
    getUniqueReferences(references) {
      return getUniqueArrayOfObjects(references, "section_id");
    },
    showAlertMessage(message, color) {
      this.$store.dispatch(
        `alert/${ADD_ALERT}`,
        {
          message: message,
          color: color,
        },
        { root: true }
      );
    },
    copyToClipboard(text, message) {
      navigator.clipboard.writeText(text).then(
        () => {
          this.showAlertMessage(message, "success");
        },
        err => {
          console.error("Could not copy text: ", err);
        }
      );
    },
    getScoreColor(score) {
      return score > 80
        ? "green"
        : score > 60
          ? "light-green"
          : score > 40
            ? "yellow"
            : score > 20
              ? "orange"
              : "red";
    },
    formatIndexValues(item) {
      const excludedFields = ["source", "score", "dataset_id"];
      const indexFields = Object.keys(item).filter(
        key => !excludedFields.includes(key)
      );
      const values = indexFields
        .map(field => {
          const value = item[field];
          return `${field}: ${value}`;
        })
        .filter(Boolean);
      return values.length ? values.join(", ") : "N/A";
    },
    saveEditedFeedback() {
      if (!this.$refs.feedbackTextarea.validate()) {
        return;
      }
      this.updateFeedback();
    },
    updateFeedback() {
      if (!this.isPrivate) {
        this.showAlertMessage(
          "You do not have permission to edit this feedback",
          "error"
        );
        return;
      }
      this.updateFeedbackFunction(this.decryptedData.project_id);
    },
    updateFeedbackFunction(project_id) {
      const updateFeedback = {
        conversation_id: this.conversation.conversationId,
        type: this.editedFeedbackType,
      };
      if (
        this.editedFeedback !== undefined &&
        this.editedFeedback.trim() !== ""
      ) {
        updateFeedback.message = this.editedFeedback;
      }
      this.RECOMMENDER_UPDATE_FEEDBACK({
        project_id: project_id,
        feedback: updateFeedback,
      }).then(
        _response => {
          this.cancelEditing();
          const updatedData = {
            conversation_id: updateFeedback.conversation_id,
            message: updateFeedback.message,
            type: updateFeedback.type,
          };
          this.conversation.feedback = {
            message: updatedData.message,
            type: updatedData.type,
          };
          this.showAlertMessage("Feedback updated successfully", "success");
          this.isEditing = false;
        },
        error => {
          console.error("Error updating insights:", error);
        }
      );
    },
    toggleEditing() {
      if (!this.isPrivate) {
        this.showAlertMessage(
          "You do not have permission to edit this feedback",
          "error"
        );
        return;
      }
      this.isEditing = !this.isEditing;
      if (this.isEditing && this.conversation.feedback) {
        if (this.conversation.feedback.message) {
          this.editedFeedback = this.conversation.feedback.message;
        } else {
          this.editedFeedback = "";
        }
        if (this.conversation.feedback.type) {
          this.editedFeedbackType = this.conversation.feedback.type;
        } else {
          this.editedFeedbackType = "";
        }
      } else {
        this.editedFeedback = "";
        this.editedFeedbackType = "";
      }
    },
    cancelEditing() {
      this.isEditing = false;
      this.editedFeedback = "";
      this.editedFeedbackType = "";
      this.showFeedbackTypeError = false;
      this.updateMessage = "";
    },
    redirectDocumentPage(item) {  
      if (!this.isPrivate) {
        this.showAlertMessage(
          "You do not have permission to view this document",
          "error"
        );
        return;
      }
      if (!item.dataset_id) {
        this.showAlertMessage("Dataset ID is not available", "error");
        return;
      }
      this.$router.push({
        path: `/projects`,
        query: {
          pid: this.decryptedData.project_id,
          stype: this.$route.query.stype,
          ptab: "mairaDatasets",
          datasetId: item.dataset_id,
          section_id: item.section_id


        }
      });
    },
    sharePublicUri() {
      let publicUri = "";
      if (
        (this.decryptedData?.api_key && this.decryptedData?.project_key) ||
        this.decryptedData?.client_key || (this.decryptedData?.project_id && this.decryptedData?.auth_token)
      ) {
        publicUri = `${window.location.href}`;
        this.copyToClipboard(publicUri, "Public URI copied to clipboard");
      } else {
        this.credentialModal = true;
      }
    },
    manualLinkShare() {
      if (!this.$refs.credentialForm.validate()) return;

      const data = this.client_key
        ? { client_key: this.client_key }
        : { project_key: this.project_key, api_key: this.api_key };

      const conversation_id = this.$route.params.conversation_id;
      const parts = conversation_id.split("-");
      const secretKey = `${parts[0]}#${parts[parts.length - 1]}`;
      const urlSafeEncryptedData = encryptData(data, secretKey);
      const baseUri = window.location.href.split("token=")[0];
      const uri = `${baseUri}token=${urlSafeEncryptedData}`;

      this.copyToClipboard(uri, "Public URI copied to clipboard");
      this.credentialModal = false;
    },
    sortConverstionContext(data){
      return [...(data || [])].sort((a, b) => new Date(a.timestamp) - new Date(b.timestamp));
    },
    // REFERENCE PREVIEW METHODS
    /**
     * Normalizes section_id for reliable matching
     * Handles URI encoding, HTML entities, and whitespace
     */
    normalizeSectionId(sectionId) {
      if (!sectionId) return '';
      
      let normalized = String(sectionId);
      
      // Safely decode URI component
      try {
        normalized = decodeURIComponent(normalized);
      } catch (e) {
        // If already decoded or invalid encoding, use as-is
      }
      
      // Decode HTML entities (handles &amp;, &quot;, etc.)
      try {
        const textarea = document.createElement('textarea');
        textarea.innerHTML = normalized;
        normalized = textarea.value;
      } catch (e) {
        // If HTML entity decoding fails, continue with current value
      }
      
      // Trim whitespace
      return normalized.trim();
    },

    /**
     * Extracts section name from link text
     * Link text format: "filename.ext - Section Name" or just "Section Name"
     */
    extractSectionNameFromLinkText(linkText) {
      if (!linkText) return null;
      
      const normalized = this.normalizeSectionId(linkText);
      
      // Pattern: "filename.ext - Section Name" or "filename - Section Name"
      const match = normalized.match(/\s*-\s*(.+)$/);
      
      if (match && match[1]) {
        return this.normalizeSectionId(match[1]);
      }
      
      // If no " - " delimiter, use the whole text (might be just section name)
      return normalized;
    },

    /**
     * Finds reference by section_id with multiple robust matching strategies
     */
    findReferenceBySectionId(sectionId, linkText, datasetId) {
      if (!this.conversation?.references) return null;
      
      // Strategy 1: Extract section name from link text (most reliable)
      // Link text format: "catalogue.csv - Daiso My Skin Care Serum Royal Jelly 20ml"
      let searchSectionId = null;
      
      if (linkText) {
        const extractedName = this.extractSectionNameFromLinkText(linkText);
        if (extractedName) {
          searchSectionId = extractedName;
        }
      }
      
      // Strategy 2: Use data attribute (may be truncated, but still useful)
      if (!searchSectionId && sectionId) {
        searchSectionId = this.normalizeSectionId(sectionId);
      }
      
      if (!searchSectionId) return null;
      
      const normalizedSearchId = searchSectionId;
      
      // Match Strategy 1: Exact match after normalization
      let reference = this.conversation.references.find(ref => {
        if (!ref.section_id) return false;
        const refNormalized = this.normalizeSectionId(ref.section_id);
        const isMatch = refNormalized === normalizedSearchId;
        
        // If dataset_id is available, use it for additional validation
        if (isMatch && datasetId && ref.dataset_id) {
          return ref.dataset_id === datasetId;
        }
        
        return isMatch;
      });
      
      if (reference) return reference;
      
      // Match Strategy 2: Case-insensitive exact match
      reference = this.conversation.references.find(ref => {
        if (!ref.section_id) return false;
        const refNormalized = this.normalizeSectionId(ref.section_id);
        const isMatch = refNormalized.toLowerCase() === normalizedSearchId.toLowerCase();
        
        if (isMatch && datasetId && ref.dataset_id) {
          return ref.dataset_id === datasetId;
        }
        
        return isMatch;
      });
      
      if (reference) return reference;
      
      // Match Strategy 3: Starts with match (handles truncated attributes)
      // If searchSectionId is short (like "Daiso"), try to find references that start with it
      if (normalizedSearchId.length < 20) {
        reference = this.conversation.references.find(ref => {
          if (!ref.section_id) return false;
          const refNormalized = this.normalizeSectionId(ref.section_id);
          return refNormalized.toLowerCase().startsWith(normalizedSearchId.toLowerCase());
        });
        
        if (reference) return reference;
      }
      
      // Match Strategy 4: Contains match (fuzzy matching for edge cases)
      reference = this.conversation.references.find(ref => {
        if (!ref.section_id) return false;
        const refNormalized = this.normalizeSectionId(ref.section_id);
        return refNormalized.toLowerCase().includes(normalizedSearchId.toLowerCase()) ||
               normalizedSearchId.toLowerCase().includes(refNormalized.toLowerCase());
      });
      
      return reference || null;
    },

    handleResponseClick(event) {
      const anchor = event.target.closest('a');
      if (!anchor) return;

      // Plain markdown/auto-detected links (not citation references) should just navigate normally via their href/target instead of going through reference lookup.
      if (anchor.hasAttribute('data-plain-link')) {
        // Only allow the browser's default navigation for safe http(s) URLs;
        // anything else (e.g. a javascript: URL smuggled through response content) falls through to preventDefault() below instead of being allowed to execute.
        if (/^https?:\/\//i.test(anchor.getAttribute('href') || '')) return;
      }

      event.preventDefault();

      const href = anchor.getAttribute('href');
      const sectionId = anchor.getAttribute('data-section-id');
      const datasetId = anchor.getAttribute('data-dataset-id');
      const linkText = anchor.textContent || anchor.innerText || '';

      // Try to find reference using robust matching (link text is primary source)
      const reference = this.findReferenceBySectionId(sectionId, linkText, datasetId);
      
      if (reference) {
        this.showPreview(reference, linkText);
      } 
      // Fallback: Handle images/PDFs with href if no reference found
      else if (href && (href.match(/\.(jpg|jpeg|png|gif|webp|pdf)$/i))) {
        this.showPreview({ 
          reference_url: href
        }, linkText);
      } 
      else {
        this.showAlertMessage(this.$vuetify.lang.t("$vuetify.gpt_history.reference_content_not_found"), "error");
      }
    },

    showPreview(reference, title) {
      let contentType = CONTENT_TYPES.TEXT;
      
      // Determine content type from reference URL or filename
      const checkUrl = (reference?.reference_url || '').toLowerCase();
      const fileName = (reference?.original_file_name || '').toLowerCase();
      
      if (checkUrl || fileName) {
        const source = checkUrl || fileName;
        
        if (source.match(/\.(jpg|jpeg|png|gif|webp)$/i) || source.includes('_desc.jpg')) {
            contentType = CONTENT_TYPES.IMAGE;
        } else if (source.match(/\.pdf$/i)) {
            contentType = CONTENT_TYPES.PDF;
        } else if (fileName.endsWith('.json')) {
            contentType = CONTENT_TYPES.JSON;
        } else if (fileName.endsWith('.csv')) {
            contentType = CONTENT_TYPES.CSV;
        }
      }
      
      this.previewModal = {
          show: true,
          title: title || this.$vuetify.lang.t("$vuetify.gpt_dataset.preview"),
          referenceData: reference,
          contentType: contentType
      };
    },

    /**
     * Determines content type from URL
     */
    getContentTypeFromUrl(url) {
      if (!url) return 'text';
      
      const urlLower = url.toLowerCase();
      if (urlLower.match(/\.(jpg|jpeg|png)$/)) return 'image';
      if (urlLower.match(/\.pdf$/)) return 'pdf';
      if (urlLower.match(/\.json$/)) return 'json';
      if (urlLower.match(/\.csv$/)) return 'csv';
      
      return 'image';  // Default
    },
    formatMarkdown(content) {
      if (!content) return '';
      
      // Step 1: Fix URLs with spaces - just encode spaces, don't touch quotes
      let processedContent = content.replace(
        /href=https:\/\/([^\s>]+\s+[^>]+\.(jpg|jpeg|png|gif|pdf|json|csv))/gi,
        (match, urlPath, ext) => {
            const fullUrl = 'https://' + urlPath;
            const fixedUrl = fullUrl.replace(/ /g, '%20');
            return `href="${fixedUrl}"`;
        }
     );
      
      // Step 2: Fix unquoted hrefs if any
      processedContent = processedContent.replace(/href=([^\s>"]+)/g, (match, url) => {
          const fixedUrl = url.replace(/ /g, '%20');
          return `href="${fixedUrl}"`;
      });
      
      // Step 3: Preserve anchor tags before markdown processing. Anchors already present in the response are rebuilt through sanitizeRawAnchorTag rather than kept verbatim -
      // the response content isn't trusted, and this is rendered via v-html with no other sanitization, so a raw onclick/onerror/javascript:-href here would otherwise execute.
      const anchorTags = [];
      processedContent = processedContent.replace(/<a[^>]*>.*?<\/a>/gs, (match) => {
          anchorTags.push(sanitizeRawAnchorTag(match));
          return `___ANCHOR_${anchorTags.length - 1}___`;
      });

      // Step 4: Preserve image tags before markdown processing
      const imgTags = [];
      processedContent = processedContent.replace(/!\[(.*?)\]\((.*?)\)/g, (match, alt, src) => {
          const trimmedSrc = src.trim();
          const safeAlt = escapeHtml(alt);
          const safeSrc = escapeHtml(trimmedSrc);
          const isSafeUrl = /^(https?:\/\/|\/|\.\/|#)/i.test(trimmedSrc);
          if (!isSafeUrl) {
              imgTags.push(`<span title="Blocked unsafe image URL"></span>`);
          } else {
              imgTags.push(`<img src="${safeSrc}" alt="${safeAlt}" style="max-width: 100%; height: auto;">`);
          }
          return `___IMG_${imgTags.length - 1}___`;
      });

      // Step 4.5: Preserve raw <img> tags before markdown processing, same as Step 3 does for <a> - these are rebuilt through sanitizeRawImgTag rather than kept verbatim.
      // Must run before the plain-text escape just below, which would otherwise swallow the backend's own time-series plot <img> (see sanitizeRawImgTag's doc comment).
      processedContent = processedContent.replace(/<img\b[^>]*\/?>/gi, (match) => {
          imgTags.push(sanitizeRawImgTag(match));
          return `___IMG_${imgTags.length - 1}___`;
      });

      // Escape any remaining <>, e.g. a raw <script> the LLM emitted, before this renders live via v-html.
      processedContent = processedContent.replace(/</g, '&lt;').replace(/>/g, '&gt;');

      // Convert markdown links [text](url) into anchor tags before markdown processing
      {
        const linkStartPattern = /\[([^\]]+)\]\(/g;
        let rebuilt = '';
        let lastIndex = 0;
        let match;
        while ((match = linkStartPattern.exec(processedContent)) !== null) {
          const urlStart = match.index + match[0].length;
          const urlEnd = findMarkdownLinkUrlEnd(processedContent, urlStart);
          if (urlEnd === -1) continue;

          const url = processedContent.slice(urlStart, urlEnd).trim();
          if (!/^https?:\/\//i.test(url)) continue;

          rebuilt += processedContent.slice(lastIndex, match.index);
          const safeLabel = escapeHtml(match[1]);
          const safeUrl = escapeHtml(url);
          anchorTags.push(`<a href="${safeUrl}" target="_blank" rel="noopener noreferrer" data-plain-link="true">${safeLabel}</a>`);
          rebuilt += `___ANCHOR_${anchorTags.length - 1}___`;

          lastIndex = urlEnd + 1;
          linkStartPattern.lastIndex = lastIndex;
        }
        rebuilt += processedContent.slice(lastIndex);
        processedContent = rebuilt;
      }

      // Autolink any remaining bare URLs (raw anchors were already extracted in Step 3).
      // Trailing sentence punctuation and unbalanced closing brackets are stripped from the URL and preserved as plain text after the link.
      processedContent = processedContent.replace(/(^|[\s(])(https?:\/\/[^\s<>"']+)/g, (match, prefix, rawUrl) => {
          const trimmedUrl = trimTrailingUrlPunctuation(rawUrl);
          if (!trimmedUrl) return match;
          const trailing = rawUrl.slice(trimmedUrl.length);
          const safeUrl = escapeHtml(trimmedUrl);
          anchorTags.push(`<a href="${safeUrl}" target="_blank" rel="noopener noreferrer" data-plain-link="true">${safeUrl}</a>`);
          return `${prefix}___ANCHOR_${anchorTags.length - 1}___${trailing}`;
      });

      // Step 5: Process markdown
      processedContent = processedContent
          .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
          .replace(/\*(.*?)\*/g, '<em>$1</em>')
          .replace(/###\s+(.*?)(\n|$)/g, '<h3>$1</h3>')
          .replace(/##\s+(.*?)(\n|$)/g, '<h2>$1</h2>')
          .replace(/#\s+(.*?)(\n|$)/g, '<h1>$1</h1>')
          .replace(/\n/g, '<br>');

      // Step 6: Restore anchor tags
      anchorTags.forEach((tag, index) => {
          // Passing tag via a replacer function (not as the replacement string directly) keeps it literal -
          // a plain-string replacement would let $&/$'/$`/$$ sequences inside tag (e.g. from a URL's query string) be reinterpreted by String.replace instead of inserted as-is.
          processedContent = processedContent.replace(`___ANCHOR_${index}___`, () => tag);
      });

      // Step 7: Restore image tags
      imgTags.forEach((tag, index) => {
          processedContent = processedContent.replace(`___IMG_${index}___`, () => tag);
      });
      
      return processedContent;
    },
  },
};
</script>

<style scoped>
.response-message {
  white-space: pre-line;
}

.response-details-text {
  color: gray;
  white-space: pre-line;
}

.coversation_detail_header {
  font-size: 25px;
}

.input-field {
  border: 2px solid #ccc;
  border-radius: 8px;
  padding: 10px;
  width: 100%;
  box-sizing: border-box;
}

.textarea {
  height: 200px;
  padding: 10px;
  box-sizing: border-box;
}

.text-subtitle-1 {
  font-weight: 600;
}

.word-break {
  word-break: break-all;
}

.not-found-wrapper {
  min-height: calc(100vh - 64px);
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
